import { DatepickerIntervalComponent } from './datepicker-interval.component';
import {
  Component, OnInit, Output, Input, SimpleChanges, OnChanges,
  ChangeDetectorRef
} from '@angular/core';
import {Observable, Subject} from 'rxjs/index';
import {Visibility} from '../enums';
import {DatepickerConfig} from './datepicker.config';
import * as moment_ from 'moment';
const moment = moment_;

@Component({
  selector: 'hxa-datepicker',
  template: `<div class="hxui-reset" *ngIf="OpenDiv">
  <div class="hxa-tabs">
    <hx-tabset class="hxa-tabset">
      <hx-tab  heading="Set interval" (select)="onTabSelect('tab1')" [active]="activeVariable">
        <hxa-datepicker-interval></hxa-datepicker-interval>
      </hx-tab>
      <hx-tab  heading="Specific date" (select)="onTabSelect('tab2')" [active]="activeVariable1">
        <div class="hxui-reset">
          <div class="hx-card hxa-datepicker-container">
            <div class="hx-card-header hxa-datepicker-header">
              <div class="hxa-datepicker-month">
                <div class="hxa-datepicker-icon" title="Previous Month" (click)="previousMonth()">
                    <a class="hx-button is-transparent"><i class="hx-icon icon-angle-left"></i></a>
                </div>
                <div class="hxa-datepicker-month-title">
                  <span>{{viewDate.toLocaleString("en-au", { month: "long", year: "numeric" })}}</span></div>
                <div class="hxa-datepicker-icon" title="Next Month" (click)="nextMonth()">
                    <a class="hx-button is-transparent"><i class="hx-icon icon-angle-right"></i></a>
                </div>
              </div>
              <div class="hxa-datepicker-week">
                <div class="hxa-datepicker-weekday" *ngFor="let weekday of week">
                  {{weekday | slice:0:3}}
                </div>
              </div>
            </div>
            <div class="hxa-datepicker-contents">
              <div class="hxa-datepicker-day" *ngFor="let day of days"
                [ngClass]="{'hxa-datepicker-day-siblingmonth': !isCurrentMonth(day),
                'hxa-datepicker-day-currentday': isCurrentDay(day),
                'hxa-datepicker-day-selectedday': isSelectedDay(day),
                'hxa-datepicker-day-invalidday': isInvalidDay(day)}"
                (click)="setSelectedDate(day)">
              <a class="hx-button is-transparent">{{day.getDate()}}</a>
              </div>
            </div>
          </div>
        </div>
      </hx-tab>
    </hx-tabset>
  </div>
</div>
<div class="hxui-reset" *ngIf="showCalendar">
  <div class="hx-card hxa-datepicker-container">
    <div class="hx-card-header hxa-datepicker-header">
      <div class="hxa-datepicker-month">
        <div class="hxa-datepicker-icon" title="Previous Month" (click)="previousMonth()">
            <a class="hx-button is-transparent"><i class="hx-icon icon-angle-left"></i></a>
        </div>
        <div class="hxa-datepicker-month-title">
          <span>{{viewDate.toLocaleString("en-au", { month: "long", year: "numeric" })}}</span></div>
        <div class="hxa-datepicker-icon" title="Next Month" (click)="nextMonth()">
            <a class="hx-button is-transparent"><i class="hx-icon icon-angle-right"></i></a>
        </div>
      </div>
      <div class="hxa-datepicker-week">
        <div class="hxa-datepicker-weekday" *ngFor="let weekday of week">
          {{weekday | slice:0:3}}
        </div>
      </div>
    </div>
    <div class="hxa-datepicker-contents">
      <div class="hxa-datepicker-day" *ngFor="let day of days"
        [ngClass]="{'hxa-datepicker-day-siblingmonth': !isCurrentMonth(day),
        'hxa-datepicker-day-currentday': isCurrentDay(day),
        'hxa-datepicker-day-selectedday': isSelectedDay(day),
        'hxa-datepicker-day-invalidday': isInvalidDay(day)}"
        (click)="setSelectedDate(day)">
      <a class="hx-button is-transparent">{{day.getDate()}}</a>
      </div>
    </div>
  </div>
</div>

`,
  styles: [`.hxa-datepicker-container{max-width:19rem;width:19rem;height:21rem;display:flex;flex-direction:column;font-size:1rem}.hxa-datepicker-header{padding:.5rem .5rem 0;flex-direction:column;align-items:initial;justify-content:space-around;font-weight:100}.hxa-datepicker-icon{cursor:pointer;display:flex;flex:1;flex-direction:column;justify-content:center;align-items:center}.hxa-datepicker-icon .hx-button{position:initial!important;top:initial!important}.hxa-datepicker-icon .hx-button.is-transparent:hover{color:#000}.hxa-datepicker-icon .hx-icon{font-size:2em;position:initial!important;top:initial!important;color:#0d4d78}.hxa-datepicker-month{display:flex;text-align:center;margin-bottom:.5rem}.hxa-datepicker-month-title{font-size:1.25em;font-weight:400;flex:3;display:flex;justify-content:center;align-items:center;color:#0d4d78}.hxa-datepicker-week{display:flex;width:100%;text-align:center}.hxa-datepicker-weekday{flex:1;color:#0d4d78;font-size:.85em}.hxa-datepicker-contents{padding:.5rem;background-color:rgba(246,246,249,.5);display:flex;flex-flow:row wrap;flex:1;justify-content:space-around;align-content:space-around}.hxa-datepicker-day{flex:1 1 14%;height:16.666%;display:flex;justify-content:center;align-items:center}.hxa-datepicker-day .hx-button{position:initial;top:initial;flex:1;font-weight:400;height:100%;padding:0;color:#41b987}.hxa-datepicker-day-siblingmonth .hx-button{color:#3b3b3b;font-weight:100}.hxa-datepicker-day-selectedday .hx-button{color:#fff;background:#41b987}.hxa-datepicker-day-invalidday .hx-button{color:#e0e0e1!important;pointer-events:none}.hxa-datepicker-day-currentday .hx-button{border:2px solid #41b987}:host{max-width:24rem;border:1px solid #d3d3d3;background:#fff}:host .hxa-tabs ::ng-deep hx-tabset ::ng-deep ul{background-color:#fff;margin-bottom:0}:host .hxa-tabs ::ng-deep hx-tabset ::ng-deep ul ::ng-deep li{width:50%}:host .hxa-tabs ::ng-deep hx-tabset ::ng-deep ul ::ng-deep li a span{font-size:medium;margin:auto}:host .hxa-tabs ::ng-deep hx-tabset ::ng-deep .hx-tab-content{padding:0}`]
})
export class DatepickerComponent implements OnInit, OnChanges {
  public OpenDiv: Boolean = true;
  public showCalendar: Boolean = true;
  public tabname1: String;
  public activeVariable: Boolean = true;
  public activeVariable1: Boolean;

  @Input()
  selectedDate: Date;

  @Input()
  validators: Array<(date: Date) => boolean>;

  @Input()
  placement: 'top' | 'bottom' | 'left' | 'right' = 'bottom';

  @Input()
  allowInterval = false;

  @Input()
  selectedDueDateInterval = '0 day(s)';

  onDateSelected: (inputDate: Date) => void;
  visibilityEnum = Visibility;
  visibility: Visibility = Visibility.Hidden;
  viewDate: Date;
  days: Array<Date> = new Array<Date>();
  week: Array<string> = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  private presentDate: Date;
  private cellCount = 41;
  private _dp: DatepickerIntervalComponent | null;
  /** Subject for notifying that the calendar has been hidden from the view */
  private readonly _onHide: Subject<any> = new Subject();

  /** The timeout ID of any current timer set to show the calendar */
  private _showTimeoutId: number;

  /** The timeout ID of any current timer set to hide the calendar */
  private _hideTimeoutId: number;

  constructor(private _changeDetectionRef: ChangeDetectorRef, private datePickerConfig: DatepickerConfig) {
    }

  // Populates the days array with the current month, and completes the view with partial dates from sibling months
  public renderCalendar(): void {
    for (let i = 0; i <= this.cellCount; i++) {
      // date will be set to the first day of the month set in this.viewDate
      const date: Date = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth());
      // Shifts the week to start from Monday, rather than Sunday, this causes the index to start at 1
      const dayOffset = date.getDay() === 0 ? 7 : date.getDay();
      this.days[i] = new Date(date.setDate(2 - dayOffset + i));
    }
  }


  public previousMonth(): void {
    this.viewDate = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() - 1);
    this.renderCalendar();
  }

  public nextMonth(): void {
    this.viewDate = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() + 1);
    this.renderCalendar();
  }

  public isCurrentMonth(inputDate: Date): boolean {
    return inputDate.getMonth() === this.viewDate.getMonth();
  }

  public isCurrentDay(inputDate: Date): boolean {
    return inputDate.getTime() === this.presentDate.getTime();
  }

  public isSelectedDay(inputDate: Date): boolean {
    if (this.selectedDate) {
      return inputDate.getTime() === this.selectedDate.getTime();
    }

    return false;
  }

  public isInvalidDay(inputDate: Date): boolean {
    return this.validators.map((fn) => fn(inputDate)).reduce((prev, next) => prev || next, false);
  }

  public setSelectedDate(date: Date): void {
    if (!this.isInvalidDay(date)) {
      this.selectedDate = date;
      this.onDateSelected(date);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.selectedDate.currentValue) {
      this.viewDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth());
    }
  }

  ngOnInit(): void {
    const date: Date = this.selectedDate ? this.selectedDate : new Date();
    this.presentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    this.viewDate = this.viewDate || new Date(date.getFullYear(), date.getMonth());
    this.renderCalendar();
    if ( this.datePickerConfig.tabSelected === 'tab1') {
     this.activeVariable1 = false;
      this.activeVariable = true;
    }
    if ( this.datePickerConfig.tabSelected === 'tab2') {
      this.activeVariable1 = true;
      this.activeVariable = false;
     }
  }

  /**
   * Shows the tooltip
   * @param delay Amount of milliseconds to the delay showing the tooltip.
   */
  show(delay: number): void {
    // Cancel the delayed hide if it is scheduled
    if (this._hideTimeoutId) {
      clearTimeout(this._hideTimeoutId);
    }
    this._showTimeoutId = window.setTimeout(() => {
      // Schedule for change detection incase the tooltip is used within a
      // component with OnPush change detection
      this._changeDetectionRef.markForCheck();
      this.visibility = Visibility.Visible;
    }, delay);

    if (this.allowInterval) {
       this.OpenDiv = true;
       this.showCalendar = false;

    } else {
     this.OpenDiv = false;
     this.showCalendar = true;
    }
  }

  /**
   * Hide the tooltip after the provided delay in ms.
   * @param delay Amount of milliseconds to delay hiding the tooltip.
   */
  hide(delay: number): void {
    // Cancel the delayed show if it is scheduled
    if (this._showTimeoutId) {
      clearTimeout(this._showTimeoutId);
    }

    this._hideTimeoutId = window.setTimeout(() => {
      this.visibility = Visibility.Hidden;
      this._onHide.next();
    }, delay);
  }

  /** Returns an observable that notifies when the tooltip has been hidden from view. */
  afterHidden(): Observable<void> {
    return this._onHide.asObservable();
  }

  isVisible(): boolean {
    return this.visibility === Visibility.Visible;
  }
  onTabSelect(tabname: String) {
     if (tabname === 'tab1') {
      this.datePickerConfig.tabSelected = tabname;
     } else {
      this.datePickerConfig.tabSelected = tabname;
     }
   }
}
